import { store } from 'store/index'
import { selectSessionId, selectOpenChatLoading, setSessionId, setOpenChatLoading } from 'store/messages'
import axios from 'axios'

export const getGuestChat = async () => {
  try {
    const state = store.getState()
    const loading = selectOpenChatLoading(state)
    const chatId = selectSessionId(state)
  
    if (loading || chatId) {
      return
    }

    store.dispatch(setOpenChatLoading(true))

    const { data } = await axios.get<{ _id: string }>('chats/guest')

    store.dispatch(setSessionId(data._id))
    store.dispatch(setOpenChatLoading(false))
    
    return data
  } catch (e) {
    console.error({ e })
    store.dispatch(setSessionId(null))
    store.dispatch(setOpenChatLoading(false))
    store.dispatch({
      text: "Unfortunately, I'm having some problem 😅. I would appreciate it if you could try again later",
      sender: 'BOT',
      type: 'text',
      ts: new Date().toISOString(),
    })
  }
}
